module.exports = __webpack_public_path__ + "img/bj1.e8845e31.png";